import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getGridV2EffectiveVersion, getIsGridV2OptedOut } from "./selectors";

export interface GridV2TrackingProperties {
  /** The grid that actually priced the user, not the LD assignment. */
  grid_version: "v1" | "v2";
  /** Sticky after an opt-out. */
  grid_v2_opted_out: boolean;
}

/**
 * The Grid V2 Tracking Spec's attribution model: two global properties on
 * every event, so Amplitude can split the legs by treatment received.
 */
export const useGridV2TrackingProperties = (): GridV2TrackingProperties => {
  const effectiveVersion = useSelector(getGridV2EffectiveVersion);
  const isOptedOut = useSelector(getIsGridV2OptedOut);

  return useMemo(
    () => ({
      grid_version: effectiveVersion === "V2" ? "v2" : "v1",
      grid_v2_opted_out: isOptedOut,
    }),
    [effectiveVersion, isOptedOut]
  );
};
